import styled from 'styled-components';

import { MobileScreen } from '../styles/ConstantMediaQuery';
import textStyle from '../styles/texts/textStyle';
import ColorConstants from '../../constants/ColorConstants';

/* TODO(JG): Atualizar o estilo desses componentes para ser igual ao XD e utilizar em todos os
títulos e subtítulos dos componentes. Ex Dashboard, Settings, etc. */

export const PageTitle = styled.h3`
    ${textStyle};
    font: 500 30px Roboto, serif;
    margin: 0 0 15px 0;
`;

export const PageTitleSmall = styled.h1`
    ${textStyle};
    font: 500 20px Roboto, serif;
    margin: 0 0 15px 0;
`;

export const PageSubtitle = styled.h3`
    color: ${ColorConstants['violent-violet']};
    font: 400 15px Roboto, serif;
    width: 50vw;

    @media ${MobileScreen} {
        line-height: 1.5;
        width: 100%;
    }
`;

export const AutomaticCardSubtitle = styled.h3`
    color: ${ColorConstants['regal-blue']};
    font-family: Helvetica;
    font-size: 18px;
    font-weight: bold;
`;

export const AutomaticCardText = styled.div`
    color: ${ColorConstants['regal-blue']};
    font-family: Helvetica;
    font-size: 15px;
`;

export const SwitchLabel = styled.div`
    color: ${ColorConstants['catskill-white']};
    font: 400 15px Roboto, serif;
    line-height: 1.5;
`;
